export const SPECIALISMS_MAX_SELECTED = 10 as const;
